import { render, staticRenderFns } from "./yiKaiPiaojinE.vue?vue&type=template&id=f5bd0b84&scoped=true&"
import script from "./yiKaiPiaojinE.vue?vue&type=script&lang=js&"
export * from "./yiKaiPiaojinE.vue?vue&type=script&lang=js&"
import style0 from "./yiKaiPiaojinE.vue?vue&type=style&index=0&id=f5bd0b84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5bd0b84",
  null
  
)

export default component.exports